<template>
  <div class="form-list-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 公告栏 -->
        <div class="notice-bar">
          <el-carousel height="50px" indicator-position="none" direction="vertical" interval="3000">
            <el-carousel-item>
              <div class="notice-item" @click="showShareDocDialog()">
                <i class="el-icon-bell"></i>
                <span>发成绩不用模板，查成绩不装软件，老师不用就亏大了！点我了解更多...</span>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="notice-item" @click="showWanSearchDialog()">
                <i class="el-icon-bell"></i>
                <span>还在打印裁剪工资条？用万能快查吧，1分钟搞定工资条查询！点我了解！</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 操作按钮区 -->
        <div class="action-bar">
          <div class="action-group">
            <el-tooltip effect="dark" content="手上已经有表格，制表有点麻烦，直接导入吧" placement="bottom">
              <el-button class="btn-primary-custom" @click="importExcel()">
                <i class="el-icon-upload2"></i> 导入Excel
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="告诉您下一步怎么操作" placement="bottom">
              <el-button class="btn-secondary-custom" @click="whatIsNextStep()">
                <i class="el-icon-question"></i> 导入后下一步？
              </el-button>
            </el-tooltip>
          </div>

          <div class="action-group">
            <el-tooltip effect="dark" content="没有现成的表格，点我制作" placement="bottom">
              <el-button class="btn-primary-custom" @click="openMakeForm()">
                <i class="el-icon-edit"></i> 手工制作新表
              </el-button>
            </el-tooltip>
          </div>

          <div class="action-group">
            <el-tooltip effect="dark" content="需要别人也管理表格和操作表格" placement="bottom">
              <el-button class="btn-secondary-custom" @click="howToUseInviteForm()">
                <i class="el-icon-share"></i> 邀请他人管理
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
          <el-table
            border
            :data="tableData"
            stripe
            class="form-table"
            :header-cell-class-name="'table-header'">
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="form_name" label="表格名称" min-width="200">
              <template slot-scope="scope">
                <span class="form-name">{{scope.row.form_name}}</span>

              </template>
            </el-table-column>

            <el-table-column prop="id" label="表单ID" width="100" align="center">
            </el-table-column>

            <el-table-column prop="id" label="类型" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.is_cycle_form=='1'" class="status-badge pending">循环表</span>
                <span v-else class="status-badge active">单次表</span>
              </template>
            </el-table-column>

            <el-table-column prop="state" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.state===1" class="status-badge pending">未发放</span>
                <span v-if="scope.row.state===2" class="status-badge active">填写中</span>
                <span v-if="scope.row.state===100" class="status-badge completed">已收回</span>
              </template>
            </el-table-column>

            <el-table-column prop="submit_count" label="数据条数" align="center" width="90">
              <template slot-scope="scope">
                <span v-if="scope.row.submit_count===0" class="data-count empty">0</span>
                <span v-else class="data-count">{{scope.row.submit_count}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="创建时间" align="center" width="160">
            </el-table-column>

            <el-table-column prop="input_pages" :formatter="convertPages" label="填写张数" width="90" header-align="center" align="center">
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="140" fixed="right">
              <template slot-scope="scope">
                <div class="action-menu">
                  <el-dropdown trigger="click" size="small">
                    <el-button type="primary" size="small" class="action-btn">
                      操作 <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="action-dropdown">
                      <el-dropdown-item>
                        <el-button @click.native.prevent="sendForm(scope.$index, tableData)" type="text" size="small">
                          <i class="el-icon-s-promotion"></i> 发放表单
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button @click.native.prevent="tackbackForm(scope.$index, tableData)" type="text" size="small">
                          <i class="el-icon-circle-close"></i> 收回表单
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button @click.native.prevent="browseData(scope.$index, tableData)" type="text" size="small">
                          <i class="el-icon-view"></i> 浏览数据
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button @click.native.prevent="editForm(scope.$index, tableData)" type="text" size="small">
                          <i class="el-icon-edit"></i> 修改表单
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button @click.native.prevent="exportToFile(scope.$index, tableData)" type="text" size="small">
                          <i class="el-icon-download"></i> 导出{{tableData[scope.$index].export_file_type || tableData[scope.$index].file_type}}
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item divided>
                        <el-button @click.native.prevent="emptyFormData(scope.$index, tableData)" type="text" size="small" class="danger-btn">
                          <i class="el-icon-delete"></i> 清空数据
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button @click.native.prevent="deleteForm(scope.$index, tableData)" type="text" size="small" class="danger-btn">
                          <i class="el-icon-delete-solid"></i> 删除表单
                        </el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 问答区 -->
        <div class="faq-section">
          <h3><i class="el-icon-question"></i> 常见问题</h3>
          <div class="faq-item">
            <div class="faq-q">表格中已有部分数据，需要填表人填写部分数据，怎么操作？</div>
            <div class="faq-a">将表格中的数据导入系统，把一到两列设置为领表凭证（如姓名、编号等），填表人录入凭证就可以领到自己应该填写的数据进行填写。</div>
          </div>
          <div class="faq-item">
            <div class="faq-q">能让一些数据不让修改吗，怎么操作？</div>
            <div class="faq-a">导入数据时把列名属性中的"能否修改"设为"禁止填表人修改"即可。</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 删除确认弹窗 -->
    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="400px" custom-class="custom-dialog">
      <div class="dialog-content">{{msg}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="delFormContentRecord">删 除</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- Excel下载弹窗 -->
    <el-dialog :close-on-click-modal="false" title="下载Excel文件" :visible.sync="downloadExcelDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">Excel文件已经生成，请点击下方按钮下载。</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadExcel" class="btn-primary-custom">下 载</el-button>
        <el-button @click="downloadExcelDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- Zip下载弹窗 -->
    <el-dialog :close-on-click-modal="false" title="下载压缩包文件" :visible.sync="downloadZipDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">
        <div v-if="current_packed_time!=''">系统中有您在 {{current_packed_time}} 生成的文件</div>
        <div v-else>压缩包文件已经生成，请点击下载按钮下载。下载后用解压工具打开。</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadExistZip" class="btn-primary-custom">下 载</el-button>
        <el-button @click="downloadZipDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 已有压缩包弹窗 -->
    <el-dialog :close-on-click-modal="false" title="系统中已有成功导出的压缩包" :visible.sync="downloadExistZipDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">
        <div class="alert-message success" v-if="is_new_zip_file=='1'">压缩包中的数据完整，可以直接下载使用。</div>
        <div class="alert-message warning" v-if="is_new_zip_file=='0'">压缩包较旧，建议重新导出。</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadExistZip" v-if="is_new_zip_file=='1'">下载已有文件</el-button>
        <el-button type="warning" @click="downloadNewZip" v-if="is_new_zip_file=='0'">重新导出并下载</el-button>
        <el-button @click="downloadExistZipDialogVisible=false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- PDF下载弹窗 -->
    <el-dialog :close-on-click-modal="false" title="下载PDF文件" :visible.sync="downloadPDFDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">PDF文件已经生成，请点击下载按钮下载。</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadPDF" class="btn-primary-custom">下 载</el-button>
        <el-button @click="downloadPDFDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 发放表格弹窗 -->
    <el-dialog :close-on-click-modal="false" title="发放表格" :visible.sync="sendFormDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">
        <p>发放表格需要在手机上操作，请用微信扫描下方二维码打开多人填表小程序：</p>
        <div class="qrcode-wrap">
          <img src="../assets/duorentianbiao-wx.jpg" />
        </div>
        <div class="steps">
          <p class="step-title">操作步骤：</p>
          <p>1. 在手机小程序下方点击"我发放的表"找到《{{selected_form_name}}》</p>
          <p>2. 点击"发放表格"按步骤操作即可</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendFormDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 下一步提示弹窗 -->
    <el-dialog title="表格导好了，下一步怎么办？" :visible.sync="howToNextStepDialogVisible" width="500px" custom-class="custom-dialog">
      <div class="dialog-content steps-list">
        <div class="step-item-dialog">
          <span class="step-num">1</span>
          <span>打开您刚才扫码登录的小程序，您会看到刚才导入的表格</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">2</span>
          <span>在手机小程序上点击表格打开，并点击"发放表格"</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">3</span>
          <span>填表人填写数据</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="howToNextStepDialogVisible = false" type="primary" class="btn-primary-custom">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 邀请管理弹窗 -->
    <el-dialog title="怎么让别人看到我发的表格？" :visible.sync="howToUseInviteFormDialogVisible" width="500px" custom-class="custom-dialog">
      <div class="dialog-content steps-list">
        <div class="step-item-dialog">
          <span class="step-num">1</span>
          <span>打开您刚才扫码登录的小程序</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">2</span>
          <span>在手机小程序上点开您想让他看到的表格</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">3</span>
          <span>点击"邀请管理员"把他邀请进来</span>
        </div>
        <div class="step-item-dialog">
          <span class="step-num">4</span>
          <span>他用小程序扫web网站上的登录二维码登录网页端即可看到表格</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="howToUseInviteFormDialogVisible = false" type="primary" class="btn-primary-custom">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 删除表格弹窗 -->
    <el-dialog title="删除表格" :visible.sync="deleteFormConfirmDialogVisible" width="450px" custom-class="custom-dialog danger-dialog">
      <div class="dialog-content">
        <div class="alert-message danger">此操作会删除表格及表格中的数据，删除后无法恢复，请谨慎操作！</div>
        <div class="confirm-text">{{msg}}</div>
        <div class="verify-box">
          <p>删除验证码：<span class="verify-code">{{random_num}}</span></p>
          <el-input v-model="tmp_random_num" placeholder="请输入上方验证码" size="medium"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteSelectedForm" type="danger">永久删除表格</el-button>
        <el-button @click="deleteFormConfirmDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 清空数据弹窗 -->
    <el-dialog title="清空表中的数据" :visible.sync="deleteFormDataConfirmDialogVisible" width="450px" custom-class="custom-dialog danger-dialog">
      <div class="dialog-content">
        <div class="alert-message danger">此操作会永久删除表格中的数据，删除后无法恢复，请谨慎操作！</div>
        <div class="confirm-text">{{msg}}</div>
        <div class="verify-box">
          <p>清空验证码：<span class="verify-code">{{random_num}}</span></p>
          <el-input v-model="tmp_random_num" placeholder="请输入上方验证码" size="medium"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptySelectedFormData" type="danger">清空表中的数据</el-button>
        <el-button @click="deleteFormDataConfirmDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 推广弹窗1 -->
    <el-dialog title="快查成绩 - 解决成绩发布难题！" width="450px" :visible.sync="shareDocDialogVisible" custom-class="custom-dialog promo-dialog">
      <div class="dialog-content promo-content">
        <div class="promo-highlight">成绩不能公开，但又需要发给家长，老师工作量太大，用这个就省事了！</div>
        <div class="feature-list">
          <div class="feature-item"><i class="el-icon-check"></i> 微信小程序，不用装软件，不用关注</div>
          <div class="feature-item"><i class="el-icon-check"></i> 发成绩时用现成的成绩单即可，不用再填模板</div>
        </div>
        <div class="qrcode-section">
          <p>立即扫码体验</p>
          <img src="/form/images/kuaicha_mp.jpg" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shareDocDialogVisible=false" class="btn-primary-custom">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 推广弹窗2 -->
    <el-dialog title="万能快查 - 解决隐私资料发布难题！" width="450px" :visible.sync="wanSearchDialogVisible" custom-class="custom-dialog promo-dialog">
      <div class="dialog-content promo-content">
        <div class="promo-highlight">工资条、个人考核等隐私资料发起简单，但工作量不小！</div>
        <div class="feature-list">
          <div class="feature-item"><i class="el-icon-check"></i> 1分钟构建查询系统，谁要谁查</div>
          <div class="feature-item"><i class="el-icon-check"></i> 省时省力，安全可靠</div>
        </div>
        <div class="qrcode-section">
          <p>立即扫码体验</p>
          <img src="/form/images/wansearch_qrcode.jpg" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wanSearchDialogVisible=false" class="btn-primary-custom">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 选择列名弹窗 -->
    <el-dialog width="450px" :close-on-click-modal="false" title="请选择作为目录名的列" :visible.sync="selectExportColumnNameDialogVisible" custom-class="custom-dialog">
      <div class="dialog-content">
        <p class="tip-text">您选择的列中的数据将作为存放文件的目录名。</p>
        <p class="tip-example">例如：选择了"姓名"列，姓名为"张三"的数据相关文件会存放到"张三"目录下。</p>
        <el-select v-model="selected_field_name" placeholder="请选择列" class="field-select">
          <el-option v-for="item in textFields" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectExportColumnNameDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="exportZipFile()" class="btn-primary-custom">立即导出</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,
        shownotify: 0,
        successDialogVisible: false,
        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,
        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',
        downloadPDFDialogVisible: false,
        howToNextStepDialogVisible: false,
        zip_file_form_id: '',
        howToUseInviteFormDialogVisible: false,
        deleteFormConfirmDialogVisible: false,
        random_num: '',
        tmp_random_num: '',
        current_packed_time: '',
        downloadExistZipDialogVisible: false,
        current_index: '',
        current_rows: '',
        current_pasted_minutes: '',
        is_new_zip_file: '0',
        deleteFormDataConfirmDialogVisible: false,
        shareDocDialogVisible: false,
        wanSearchDialogVisible: false,
        selectExportColumnNameDialogVisible: false,
        textFields: [],
        selected_field_name: ''
      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME')
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.loadData()
    },
    methods: {
      loadData() {
        let that = this
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_load_forms.jsp'
        this.axios.get(requestUrl, {
          params: { username: that.username }
        }).then(function(response) {
          that.tableData = response.data
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state
        if (typeof(state) === 'undefined' || state === 1) {
          return '未发放'
        }
        if (state === 2) {
          return '正在填写'
        }
        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages
        if (typeof(inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }
        if (inputPages > 1) {
          return '多张/人'
        }
      },
      viewExam(index, rows) {
        var examID = rows[index].id
        var exam = rows[index].exam
        console.log('查看成绩单:' + exam)
        this.$router.push({
          name: 'exam_detail',
          params: { id: examID, exam: exam }
        })
      },
      editForm(index, rows) {
        if (rows[index].conditions != '') {
          var msg = '用于数据修订的表格不能修改表结构，如果需要修改，请从Excel中重新导入！'
          this.$alert(msg, '提示', {
            confirmButtonText: '好的',
            callback: action => { this.function() }
          })
          return
        }
        if (rows[index].submit_count > 0) {
          var msg = '"' + rows[index].form_name + '"中有数据，为了防止丢失已经填写的数据，必须先清空数据并收回表格才能修改！'
          this.$alert(msg, '提示', {
            confirmButtonText: '好的',
            callback: action => { this.function() }
          })
          return
        }
        var formId = rows[index].id
        this.$router.push({
          name: 'make_form',
          params: { form_id: formId, action: 'EDIT' }
        })
      },
      deleteForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id
        this.position = index
        this.selected_form_id = rows[index].id
        var state = rows[index].state
        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写，如要删除，请先收回表格！', '提示', {
            confirmButtonText: '确定',
            callback: action => { this.function() }
          })
          return
        }
        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据，删除前确保已经备份好了数据。如已备份且确实需要删除，请输入删除验证码后点"删除"，否则请点击"取消"!'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗？'
        }
        this.deleteFormConfirmDialogVisible = true
      },
      deleteSelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入删除验证码!')
          return
        }
        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('删除验证码不正确，请重新输入!')
        } else {
          this.delFormContentRecord()
        }
      },
      delFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
          params: { form_id: that.selected_form_id, equipment: that.username }
        }).then(function(response) {
          that.tableData.splice(that.position, 1)
          that.tmp_random_num = ''
          that.$message.success('删除成功！')
        }).catch(function(error) {
          console.log(error)
        })
      },
      tackbackForm(index, rows) {
        let that = this
        this.position = index
        this.selected_form_id = rows[index].id
        this.msg = '收回表格会停止填写表格，尚未填写的将不能继续填写，如要填写需要重新发放，要收回表格吗？'
        that.$confirm(this.msg, '操作提示', {
          confirmButtonText: '全部收回',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/form/web/_tack_back_form.jsp'
          that.axios.get(requestUrl, {
            params: { form_id: that.selected_form_id }
          }).then(function(response) {
            that.loadData()
            that.$message.success('收回成功！')
          }).catch(function(error) {
            console.log(error)
          })
        }).catch(() => {})
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this
        this.$router.push({
          name: 'exam_edit',
          params: { id: that.selectedExamID }
        })
      },
      importExcel() {
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },
      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this
        this.position = index
        this.selectedExamID = rows[index].id
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
          params: { id: that.selectedExamID }
        }).then(function(response) {
          that.students = response.data
          that.unReadDialogFormVisible = true
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        let that = this
        this.current_packed_time = rows[index].packed_finish_time
        this.current_pasted_minutes = rows[index].pasted_minutes
        this.current_index = index
        this.current_rows = rows
        var fileType = rows[index].export_file_type || rows[index].file_type

        if(fileType == 'ZIP'){
          this.$alert('网页端只提供单次表的excel格式的文件导出。此表导出为压缩包，数据量太大会导致浏览器卡死，请用手机微信小程序导出，导出后请按照微信小程序的提示操作！')
          return
        }

        var isCycleForm=rows[index].is_cycle_form
        if(isCycleForm=='1'){
          this.$alert('网页端只提供单次表的excel格式的文件导出。此表导出为循环表，数据量太大会导致浏览器卡死，请用手机微信小程序导出，导出后请按照微信小程序的提示操作！')
          return
        }



        if (fileType == 'ZIP') {
          if (this.current_packed_time !== '') {
            // this.showExistZipDialog(index, rows)
            this.$alert('此表导出为压缩包，请用手机微信小程序导出，导出后请按照微信小程序的提示操作！')
          } else {
            var form_id = rows[index].id
            this.selected_form_id = rows[index].id
            this.loadTextFields(form_id)
            this.selectExportColumnNameDialogVisible = true
          }
        } else {
          this.export(index, rows)
        }
      },
      showExistZipDialog(index, rows) {
        var selected_form_id = rows[this.current_index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_load_export_zip_state.jsp'
        this.axios.get(requestUrl, {
          params: { form_id: selected_form_id }
        }).then(function(response) {
          that.is_new_zip_file = response.data.is_new_zip
          that.downloadExistZipDialogVisible = true
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadExistZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false
        var selected_form_id = this.current_rows[this.current_index].id
        var url = '/form/download.jsp?form_id=' + selected_form_id
        window.open(url)
      },
      export (index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '导出中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        var fileType = rows[index].export_file_type || rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip_ex.jsp'
        }
        this.axios.get(requestUrl, {
          params: { username: that.username, form_id: formId, selected_dir_name: that.selected_field_name }
        }).then(function(response) {
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xlsx'
            that.downloadExcelDialogVisible = true
            var timestamp = new Date().getTime();
            that.current_download_file_name = fileName + '?t=' + timestamp
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            that.current_download_file_name = fileName
            that.selected_field_name = ''
            that.zip_file_form_id = formId
          }
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '导出中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_export_to_pdf.jsp'
        this.axios.get(requestUrl, {
          params: { username: that.username, form_id: formId }
        }).then(function(response) {
          that.downloadPDFDialogVisible = true
          that.current_download_file_name = response.data.pdf_filename
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadNewZip() {
        var selected_form_id = this.current_rows[this.current_index].id
        this.loadTextFields(selected_form_id)
        this.selectExportColumnNameDialogVisible = true
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.sendFormDialogVisible = true
      },
      browseData(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name
        this.$router.push({
          name: 'browse_all_data',
          params: { form_id: formId, form_name: formName }
        })
      },
      openMakeForm() {
        this.$router.push('/make_form')
      },
      validCondition(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name
        this.$router.push({
          name: 'set_valid_condition',
          params: { form_id: formId, form_name: formName }
        })
      },
      whatIsNextStep() {
        this.howToNextStepDialogVisible = true
      },
      collectAdvice(index, rows) {},
      howToUseInviteForm() {
        this.howToUseInviteFormDialogVisible = true
      },
      emptyFormData(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.tmp_random_num = ''
        this.msg = '要清空《' + rows[index].form_name + '》的全部数据吗？'
        this.selected_form_id = rows[index].id
        this.deleteFormDataConfirmDialogVisible = true
      },
      emptySelectedFormData() {
        let that = this
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空数据验证码!')
          return
        }
        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空数据验证码不正确，请重新输入!')
          return
        }
        var requestUrl = '/form/web/_empty_form_data.jsp'
        this.axios.get(requestUrl, {
          params: { form_id: that.selected_form_id, equipment: that.username }
        }).then(function(response) {
          that.deleteFormDataConfirmDialogVisible = false
          that.tmp_random_num = ''
          that.loadData()
          that.$message.success('清空成功！')
        }).catch(function(error) {
          console.log(error)
        })
      },
      showShareDocDialog() {
        this.shareDocDialogVisible = true
      },
      showWanSearchDialog() {
        this.wanSearchDialogVisible = true
      },
      loadTextFields(form_id) {
        let that = this
        var requestUrl = '/form/web/_load_text_fileds.jsp'
        this.axios.get(requestUrl, {
          params: { form_id: form_id }
        }).then(function(response) {
          that.textFields = []
          let fields = response.data.fields
          for (var i = 0; i < fields.length; i++) {
            let field = fields[i]
            let obj = { label: field.field_name, value: field.field_name }
            that.textFields.push(obj)
          }
          that.$forceUpdate()
        }).catch(function(error) {
          console.log(error)
        })
      },
      exportZipFile() {
        let that = this
        if (this.selected_field_name == '') {
          this.$message.error('请选择列名!')
          return
        }
        that.selectExportColumnNameDialogVisible = false
        that.export(that.current_index, that.current_rows)
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .form-list-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .content-col {
    padding-left: 20px;
  }

  /* 公告栏 */
  .notice-bar {
    background: linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%);
    border-radius: 10px;
    margin-bottom: 20px;
    border-left: 4px solid #FFCB2F;
    overflow: hidden;
  }

  .notice-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 20px;
    cursor: pointer;
    font-size: 15px;
    color: #8b6914;
    transition: all 0.3s;
  }

  .notice-item:hover {
    background: rgba(255, 203, 47, 0.1);
  }

  .notice-item i {
    margin-right: 10px;
    font-size: 18px;
    color: #FFCB2F;
  }

  /* 操作按钮区 */
  .action-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 30px;
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .action-group {
    display: flex;
    gap: 10px;
  }

  /* 主按钮 - 蓝色渐变 */
  .btn-primary-custom {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(20, 133, 251, 0.3);
  }

  /* 次要按钮 - 绿色 */
  .btn-secondary-custom {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    border: none;
    color: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    transition: all 0.3s ease;
  }

  .btn-secondary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(44, 203, 146, 0.3);
  }

  /* 表格区域 */
  .table-section {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
    margin-bottom: 20px;
  }

  .form-table {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .form-table .el-table__header-wrapper th {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    color: #495057;
    font-weight: 600;
    font-size: 13px;
    padding: 12px 0;
  }

  ::v-deep .form-table .el-table__row {
    font-size: 13px;
  }

  ::v-deep .form-table .el-table__row:hover td {
    background: #f8f9fa;
  }

  /* 表格名称 */
  .form-name {
    font-weight: 500;
    color: #333;
  }

  .form-name.shared {
    color: #1485FB;
  }

  .form-name.shared i {
    margin-right: 5px;
  }

  /* 状态标签 */
  .status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-badge.pending {
    background: #fff3cd;
    color: #856404;
  }

  .status-badge.active {
    background: #d4edda;
    color: #155724;
  }

  .status-badge.completed {
    background: #e2e3e5;
    color: #383d41;
  }

  /* 数据条数 */
  .data-count {
    display: inline-block;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
  }

  .data-count.empty {
    background: #e9ecef;
    color: #6c757d;
  }

  /* 操作按钮 */
  .action-menu {
    display: flex;
    justify-content: center;
  }

  .action-btn {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    border-radius: 6px;
  }

  ::v-deep .action-dropdown .el-dropdown-menu__item {
    padding: 8px 20px;
  }

  ::v-deep .action-dropdown .el-button--text {
    color: #606266;
    font-size: 13px;
  }

  ::v-deep .action-dropdown .el-button--text:hover {
    color: #1485FB;
  }

  ::v-deep .action-dropdown .danger-btn {
    color: #f56c6c;
  }

  ::v-deep .action-dropdown .danger-btn:hover {
    color: #f78989;
  }

  /* 问答区 */
  .faq-section {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  .faq-section h3 {
    margin: 0 0 20px;
    font-size: 16px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .faq-section h3 i {
    color: #1485FB;
  }

  .faq-item {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px dashed #e9ecef;
  }

  .faq-item:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }

  .faq-q {
    font-weight: 600;
    color: #1485FB;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .faq-a {
    color: #666;
    font-size: 13px;
    line-height: 1.6;
    padding-left: 10px;
    border-left: 3px solid #2CCB92;
  }

  /* 弹窗样式 */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 15px 20px;
  }

  ::v-deep .custom-dialog .el-dialog__title {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 20px;
  }

  ::v-deep .danger-dialog .el-dialog__header {
    background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  }

  ::v-deep .promo-dialog .el-dialog__header {
    background: linear-gradient(135deg, #FFCB2F 0%, #ffb700 100%);
  }

  ::v-deep .promo-dialog .el-dialog__title {
    color: #333;
  }

  .dialog-content {
    color: #555;
    line-height: 1.6;
  }

  .alert-message {
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .alert-message.danger {
    background: #fff5f5;
    color: #c53030;
    border-left: 4px solid #f56c6c;
  }

  .alert-message.success {
    background: #f0fff4;
    color: #276749;
    border-left: 4px solid #2CCB92;
  }

  .alert-message.warning {
    background: #fffaf0;
    color: #c05621;
    border-left: 4px solid #FFCB2F;
  }

  .confirm-text {
    font-size: 15px;
    color: #333;
    margin-bottom: 15px;
    font-weight: 500;
  }

  .verify-box {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
  }

  .verify-box p {
    margin: 0 0 10px;
    font-size: 14px;
  }

  .verify-code {
    font-size: 24px;
    font-weight: 700;
    color: #f56c6c;
    letter-spacing: 5px;
  }

  /* 步骤列表 */
  .steps-list {
    padding: 10px 0;
  }

  .step-item-dialog {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .step-item-dialog:last-child {
    margin-bottom: 0;
  }

  .step-item-dialog .step-num {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 600;
    margin-right: 15px;
    flex-shrink: 0;
  }

  /* 二维码区域 */
  .qrcode-wrap {
    text-align: center;
    padding: 20px;
  }

  .qrcode-wrap img {
    width: 180px;
    height: 180px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .steps {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-top: 15px;
  }

  .steps .step-title {
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
  }

  .steps p {
    margin: 5px 0;
    font-size: 14px;
  }

  /* 推广弹窗内容 */
  .promo-content {
    text-align: center;
  }

  .promo-highlight {
    background: linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%);
    color: #8b6914;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 500;
  }

  .feature-list {
    text-align: left;
    margin-bottom: 20px;
    padding: 0 20px;
  }

  .feature-item {
    margin-bottom: 10px;
    font-size: 14px;
    color: #555;
  }

  .feature-item i {
    color: #2CCB92;
    margin-right: 8px;
  }

  .qrcode-section {
    text-align: center;
  }

  .qrcode-section p {
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  .qrcode-section img {
    width: 160px;
    height: 160px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  /* 选择列名弹窗 */
  .tip-text {
    font-size: 14px;
    color: #555;
    margin-bottom: 10px;
  }

  .tip-example {
    font-size: 13px;
    color: #888;
    margin-bottom: 20px;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 6px;
  }

  .field-select {
    width: 100%;
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .action-bar {
      flex-wrap: wrap;
      gap: 15px;
    }

    .action-group {
      flex: 1;
      min-width: 200px;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      padding: 10px;
    }

    .content-col {
      padding-left: 0;
      margin-top: 15px;
    }

    .action-bar {
      flex-direction: column;
      align-items: stretch;
    }

    .action-group {
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form_list.vue